import React, { useState } from 'react';
import { ChevronDown, ChevronRight, ExternalLink, FileText } from 'lucide-react';
import { termsDocsFor, useQuoteTermsMode, QuoteTermsPicker } from './_quoteTerms';

// Terms of Trade previews for the runner's Preview Quote PDFs step (same pick carries to Send Quote).
export function TermsPreviewSection({ api, jobId, quotes, pdfBust }) {
  const [mode, setMode] = useQuoteTermsMode(api, !!jobId, jobId);
  const [open, setOpen] = useState({});
  if (!mode) return null;
  const rows = [];
  termsDocsFor(mode).forEach((t) => {
    if (t.perQuote && quotes.length) {
      quotes.forEach((q) => rows.push({ key: `${t.key}-${q.id}`, label: `${t.label}${q.appraisal_no ? ` · A${q.appraisal_no}` : ''}`, route: t.route, id: q.id }));
    } else rows.push({ key: t.key, label: t.label, route: t.route, id: jobId });
  });
  const url = (r) => `${process.env.REACT_APP_BACKEND_URL}/api${r.route.replace('{appraisal_id}', r.id)}?_bust=${pdfBust}&inline=1`;
  return (
    <div className="mb-5" data-testid="wf-terms-preview">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-orange-700 font-semibold mb-2">
        <FileText size={12} /> Terms of Trade
      </div>
      <QuoteTermsPicker mode={mode} onChange={setMode} />
      {rows.length === 0 && <div className="text-sm text-slate-500 italic" data-testid="wf-terms-preview-none">No Terms of Trade will be attached.</div>}
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.key} className="border border-slate-200 rounded-lg overflow-hidden bg-white" data-testid={`wf-terms-preview-panel-${r.key}`}>
            <div className={`flex items-center gap-3 px-4 py-3 transition-colors ${open[r.key] ? 'bg-orange-50' : 'bg-slate-50 hover:bg-slate-100'}`}>
              <button onClick={() => setOpen((p) => ({ ...p, [r.key]: !p[r.key] }))} data-testid={`wf-terms-preview-toggle-${r.key}`}
                className="flex-1 flex items-center gap-3 text-left">
                {open[r.key] ? <ChevronDown className="w-4 h-4 text-orange-700" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
                <span className="text-sm font-semibold text-slate-800">{r.label}</span>
              </button>
              <a href={url(r)} target="_blank" rel="noopener noreferrer" data-testid={`wf-terms-preview-open-tab-${r.key}`}
                className="inline-flex items-center gap-1 px-2.5 py-1 text-[11px] bg-white border border-sky-300 text-sky-700 rounded hover:bg-sky-50">
                <ExternalLink size={11} /> New tab
              </a>
            </div>
            {open[r.key] && (
              <iframe src={url(r)} title={r.label} data-testid={`wf-terms-preview-iframe-${r.key}`} className="w-full bg-white border-t border-slate-200" style={{ height: '560px', border: 'none' }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
